export const CMS_UTM_SOURCE = 'cms_source'

export const CIRCLE_360_UTM_SOURCES = {
  circle_360_returning_user_email: 'circle_360_returning_user_email',
  circle_360_password_reset: 'circle_360_password_reset',
  shipt_activation_email: 'shipt_activation_email',
  targetemail: 'targetemail',
  targetweb: 'targetweb',
  targetapp: 'targetapp',
  shipt_activation_email_reminder_7: 'shipt_activation_email_reminder_7',
  shipt_activation_email_reminder_14: 'shipt_activation_email_reminder_14',
}

export const isCircle360UtmSource = (utm_source: string) => utm_source in CIRCLE_360_UTM_SOURCES

export const CIRCLE_360_MANAGEMENT_LINK =
  'https://www.target.com/l/target-circle/-/N-pzno9?goTo=APP-137217#Circle360'
